module.exports = __webpack_public_path__ + "img/boxed-1.5268657d.jpg";